import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { CrossFlowProvider } from './lib/CrossFlowProvider';
export { useCrossFlow, withCrossFlow, Journeys, Targets, Reasons } from './index';
export var AtlasProvider = function AtlasProvider(props) {
  return /*#__PURE__*/React.createElement(CrossFlowProvider, _extends({}, props, {
    originProduct: "atlas"
  }));
};
export default AtlasProvider;